import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="border-t border-border">
      <div className="container-wide py-16 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-4">
            <Link to="/" className="inline-block mb-6">
              <img 
                src="https://customer-assets.emergentagent.com/job_print-studio-53/artifacts/40b5uz8w_Colour%20Box.webp" 
                alt="ColourBox"
                className="h-12 w-auto"
              />
            </Link>
            <p className="text-sm text-muted-foreground mb-4">
              A brand of Adzura Media (OPC) Pvt Ltd
            </p>
            <p className="text-sm text-muted-foreground">
              Signage, printing, display, and branding production.
            </p>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2 md:col-start-7">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-6">
              Navigate
            </h4>
            <nav className="flex flex-col gap-4">
              <Link
                to="/"
                data-testid="footer-home-link"
                className="text-sm hover:text-primary transition-colors"
              >
                Home
              </Link>
              <Link
                to="/services"
                data-testid="footer-services-link"
                className="text-sm hover:text-primary transition-colors"
              >
                Services
              </Link>
              <Link
                to="/work"
                data-testid="footer-work-link"
                className="text-sm hover:text-primary transition-colors"
              >
                Work
              </Link>
              <Link
                to="/quote"
                data-testid="footer-quote-link"
                className="text-sm hover:text-primary transition-colors"
              >
                Get Quote
              </Link>
            </nav>
          </div>

          {/* Services */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-6">
              Services
            </h4>
            <nav className="flex flex-col gap-4">
              <Link
                to="/services"
                className="text-sm hover:text-primary transition-colors"
              >
                Sign Boards
              </Link>
              <Link
                to="/services"
                className="text-sm hover:text-primary transition-colors"
              >
                LED Displays
              </Link>
              <Link
                to="/services"
                className="text-sm hover:text-primary transition-colors"
              >
                Flex Printing
              </Link>
              <Link
                to="/services"
                className="text-sm hover:text-primary transition-colors"
              >
                Laser Cutting
              </Link>
            </nav>
          </div>

          {/* CTA */}
          <div className="md:col-span-2">
            <h4 className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-6">
              Get Started
            </h4>
            <Link
              to="/quote"
              data-testid="footer-cta"
              className="inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-widest border-b border-foreground/20 pb-1 hover:border-primary hover:text-primary transition-all duration-300"
            >
              Request Quote
              <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            {currentYear} ColourBox. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground">
            A brand of Adzura Media (OPC) Pvt Ltd
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
